import graphqlClient from "../../../apollo";

class CompanyProvider {

    getMyCompanyId() {
        return graphqlClient.query({
            query: require('./gql/myCompanyId.graphql'),
            fetchPolicy: "network-only"
        })
    }

    companyAfipStatus(id) {
        return graphqlClient.query({
            query: require('./gql/companyAfipStatus.graphql'),
            variables: id != null ? { id } : {},
            fetchPolicy: "network-only"
        })
    }
}

export default new CompanyProvider()
